import { Inspector } from '@sequencehq/core-components'
import { ActivityLogsInspectorItem } from 'ActivityLogs/index'
import {
  GoCardlessInspectorItem,
  GoCardlessMandatesListWidget,
  HubspotInspectorItem,
  LinkGoCardlessCustomerWidget,
  LinkHubSpotCustomerWidget,
  LinkQuickbooksCustomerWidget,
  LinkSalesforceAccountWidget,
  LinkStripeCustomerWidget,
  LinkXeroCustomerWidget,
  QuickBooksInspectorItem,
  SalesforceInspectorItem,
  StripeInspectorItem,
  XeroInspectorItem,
  LinkRilletCustomerWidget,
  RilletInspectorItem,
  LinkNetsuiteCustomerWidget,
  NetsuiteInspectorItem
} from 'Integrations/index'
import {
  AttioCustomerInspectorItem,
  LinkAttioCustomerWidget
} from 'Integrations/integrationsConfig/attio/InspectorItem/AttioInspectorItem'
import { FC } from 'react'
import { useCustomerContext } from './hooks/useCustomerContext'

export const CustomerOverviewInspector: FC = () => {
  const { customer } = useCustomerContext()

  return (
    <Inspector>
      <Inspector.ItemGroup>
        <ActivityLogsInspectorItem
          entityId={customer.id}
          entityType="CUSTOMER"
          enabled
        />
        <AttioCustomerInspectorItem customerId={customer.id}>
          <LinkAttioCustomerWidget customerId={customer.id} />
        </AttioCustomerInspectorItem>
        <XeroInspectorItem>
          <LinkXeroCustomerWidget customerId={customer.id} />
        </XeroInspectorItem>
        <QuickBooksInspectorItem>
          <LinkQuickbooksCustomerWidget customerId={customer.id} />
        </QuickBooksInspectorItem>
        <NetsuiteInspectorItem>
          <LinkNetsuiteCustomerWidget customerId={customer.id} />
        </NetsuiteInspectorItem>
        <HubspotInspectorItem>
          <LinkHubSpotCustomerWidget customerId={customer.id} />
        </HubspotInspectorItem>
        <SalesforceInspectorItem>
          <LinkSalesforceAccountWidget customerId={customer.id} />
        </SalesforceInspectorItem>
        <StripeInspectorItem>
          <LinkStripeCustomerWidget customerId={customer.id} />
        </StripeInspectorItem>
        <GoCardlessInspectorItem>
          <LinkGoCardlessCustomerWidget customerId={customer.id} />
          <GoCardlessMandatesListWidget customerId={customer.id} />
        </GoCardlessInspectorItem>
        <RilletInspectorItem>
          <LinkRilletCustomerWidget customerId={customer.id} />
        </RilletInspectorItem>
      </Inspector.ItemGroup>
    </Inspector>
  )
}
